import { noop } from 'lodash';
import i18n from 'i18n';
import requester from 'utils/requester';
import api from 'config/api';
import { DEFAULT_PIN } from 'config';

import { hideLoader, showLoader } from 'actions/loader';
import { showToast } from 'actions/toast';
import * as types from './types';

export const setPin =
  (newPin, oldPin, onSuccess = noop) =>
  async (dispatch) => {
    dispatch({ type: types.SET_PIN });
    dispatch(showLoader());

    try {
      if (newPin === DEFAULT_PIN) throw new Error(i18n.t('pc.pinDefaultError'));

      await requester({
        method: 'put',
        url: `${api.host}${api.endpoints.pin}`,
        headers: {
          'Content-Type': 'application/json;charset=utf-8',
        },
        data: JSON.stringify({ newPin, oldPin }),
      });

      onSuccess();
      dispatch(setPinSuccess(newPin));
      dispatch(showToast({ options: { toastText: i18n.t('pc.saveChanges') } }));
    } catch (error) {
      dispatch(setPinError(error.message));
    } finally {
      dispatch(hideLoader());
    }
  };

const setPinSuccess = (newPin) => {
  return {
    type: types.SET_PIN_SUCCESS,
    payload: newPin,
  };
};

export const setPinError = (error) => {
  return {
    type: types.SET_PIN_ERROR,
    payload: error,
  };
};

export const checkPin =
  ({ pin, onModalConfirm }) =>
  (dispatch) => {
    dispatch({
      type: types.CHECK_PIN,
    });

    requester({
      method: 'post',
      url: `${api.host}${api.endpoints.checkPin}`,
      headers: {
        'Content-Type': 'application/json;charset=utf-8',
      },
      data: JSON.stringify({ pin: pin }),
    })
      .then((data) => {
        dispatch(onCheckPinSuccess(pin));
        onModalConfirm();
      })
      .catch(() => {
        dispatch(onCheckPinError(true));
      });
  };

export const gotToRestorePinPage = () => (dispatch, _, history) => {
  history.push('/profile/authorization/restore/pin');
};

const onCheckPinSuccess = (pin) => {
  return {
    type: types.CHECK_PIN_SUCCESS,
    payload: pin,
  };
};

const onCheckPinError = (error) => {
  return {
    type: types.CHECK_PIN_ERROR,
    payload: error,
  };
};

export const setParentalPurchase = (payload) => ({
  type: types.SET_PURCHASE,
  payload,
});

export const setParentalAge = (payload) => ({
  type: types.SET_AGE,
  payload,
});

export const setParentalIsEnabled = (payload) => ({
  type: types.SET_ENABLED,
  payload,
});
